import React, { useState, useRef } from "react";
import "./AddProduct.css";
import upload_area from "../Assets/upload_area.svg";
import { backend_url, auth_url } from "../../App";
import { useEffect } from "react";
import * as XLSX from "xlsx";

const AddProduct = () => {
  // Mode state for individual vs bulk upload
  const [uploadMode, setUploadMode] = useState("individual"); // 'individual' or 'bulk'
  const [bulkFile, setBulkFile] = useState(null);
  const [bulkUploading, setBulkUploading] = useState(false);
  const [bulkProgress, setBulkProgress] = useState({ current: 0, total: 0 });

  // Updated state for multiple images
  const [images, setImages] = useState({
    image_main: null,
    image_back: null,
    image_side: null,
  });

  const [productDetails, setProductDetails] = useState({
    name: "",
    description: "",
    image_main: "",
    image_back: "",
    image_side: "",
    category: "Men",
    productType: "", // New field for product type when category is Accessories
    new_price: "",
    old_price: "",
    sizeSCheckbox: false,
    sizeSCH: "0",
    sizeSSH: "0",
    sizeSLE: "0",
    sizeSSL: "0",
    sizeMCheckbox: false,
    sizeMCH: "0",
    sizeMSH: "0",
    sizeMLE: "0",
    sizeMSL: "0",
    sizeLCheckbox: false,
    sizeLCH: "0",
    sizeLSH: "0",
    sizeLLE: "0",
    sizeLSL: "0",
    sizeXLCheckbox: false,
    sizeXLCH: "0",
    sizeXLSH: "0",
    sizeXLLE: "0",
    sizeXLSL: "0",
    sizeXXLCheckbox: false,
    sizeXXLCH: "0",
    sizeXXLSH: "0",
    sizeXXLLE: "0",
    sizeXXLSL: "0",
    // Accessory-specific fields
    waist: "",
    thighs: "",
    length: "",
    stock_qtyS: "",
    stock_qtyM: "",
    stock_qtyL: "",
    stock_qtyXL: "",
    stock_qtyXXL: "",
    stock_leftS: "",
    stock_leftM: "",
    stock_leftL: "",
    stock_leftXL: "",
    stock_leftXXL: "",
    stock_balS: "",
    stock_balM: "",
    stock_balL: "",
    stock_balXL: "",
    stock_balXXL: "",
    stock_qty: "",
    stock_left: "",
    stock_bal: "",
    Date: new Date().toLocaleDateString(),
    available: "",
    updated_by: "Admin",
  });

  // Bulk image upload state
  const [bulkImageFiles, setBulkImageFiles] = useState([]);
  const [bulkImageUploadResult, setBulkImageUploadResult] = useState([]);
  const [bulkImageUploading, setBulkImageUploading] = useState(false);
  const bulkImageInputRef = useRef();

  // Template selection state
  const [selectedTemplate, setSelectedTemplate] = useState("shirts");

  // Git status state
  const [gitStatus, setGitStatus] = useState(null);
  const [gitStatusLoading, setGitStatusLoading] = useState(false);
  const [openingCommit, setOpeningCommit] = useState(false);

  // Check Git status on component mount
  useEffect(() => {
    checkGitStatus();
  }, []);

  const checkGitStatus = async () => {
    setGitStatusLoading(true);
    try {
      const response = await fetch(`${backend_url}/admin/git-status`, {
        method: "GET",
        headers: {
          "auth-token": localStorage.getItem("auth-token"),
        },
      });

      const result = await response.json();
      if (result.success) {
        setGitStatus(result);
      } else {
        console.error("Failed to get Git status:", result.message);
        setGitStatus(null);
      }
    } catch (error) {
      console.error("Error checking Git status:", error);
      setGitStatus(null);
    } finally {
      setGitStatusLoading(false);
    }
  };

  const openLastCommit = () => {
    if (
      !gitStatus ||
      !gitStatus.gitConfig ||
      !gitStatus.gitConfig.lastCommitUrl
    )
      return;
    setOpeningCommit(true);
    try {
      window.open(gitStatus.gitConfig.lastCommitUrl, "_blank");
    } finally {
      setOpeningCommit(false);
    }
  };

  // Generate Excel template based on selected type
  const generateExcelTemplate = () => {
    let templateData = [];
    let fileName = "";

    switch (selectedTemplate) {
      case "shirts":
        templateData = [
          {
            "Product Name": "FS0001",
            Description:
              "Premium quality cotton t-shirt with comfortable fit and modern design",
            Category: "Men",
            "New Price": 999,
            "Old Price": 1299,
            "Image Main (Backend Filename)": "product_1234567890123.webp",
            "Image Optional 2 (Backend Filename)": "product_1234567890124.webp",
            "Image Optional 3 (Backend Filename)": "product_1234567890125.webp",
            "Size S Available": "Yes",
            "Size S Chest (inches)": 36,
            "Size S Shoulder (inches)": 16,
            "Size S Length (inches)": 28,
            "Size S Sleeve (inches)": 24,
            "Size S Stock Balance": 10,
            "Size M Available": "Yes",
            "Size M Chest (inches)": 38,
            "Size M Shoulder (inches)": 17,
            "Size M Length (inches)": 29,
            "Size M Sleeve (inches)": 25,
            "Size M Stock Balance": 15,
            "Size L Available": "Yes",
            "Size L Chest (inches)": 40,
            "Size L Shoulder (inches)": 18,
            "Size L Length (inches)": 30,
            "Size L Sleeve (inches)": 26,
            "Size L Stock Balance": 12,
            "Size XL Available": "Yes",
            "Size XL Chest (inches)": 42,
            "Size XL Shoulder (inches)": 19,
            "Size XL Length (inches)": 31,
            "Size XL Sleeve (inches)": 27,
            "Size XL Stock Balance": 8,
            "Size XXL Available": "No",
            "Size XXL Chest (inches)": 0,
            "Size XXL Shoulder (inches)": 0,
            "Size XXL Length (inches)": 0,
            "Size XXL Sleeve (inches)": 0,
            "Size XXL Stock Balance": 0,
            Notes:
              "Upload images as: FS0001_1.jpg (main), FS0001_2.jpg (optional), FS0001_3.jpg (optional). Use backend filenames from CSV mapping in image columns above.",
          },
        ];
        fileName = `shirts_upload_template_${
          new Date().toISOString().split("T")[0]
        }.xlsx`;
        break;

      case "jeans":
        templateData = [
          {
            "Product Name": "FS0002",
            Description:
              "Premium quality denim jeans with comfortable fit and modern design",
            Category: "Accessories",
            "Product Type": "Jeans",
            "New Price": 1999,
            "Old Price": 2499,
            "Image Main (Backend Filename)": "product_1234567890123.webp",
            "Image Optional 2 (Backend Filename)": "product_1234567890124.webp",
            "Image Optional 3 (Backend Filename)": "product_1234567890125.webp",
            "Waist (inches)": 32,
            "Thighs (inches)": 24,
            "Length (inches)": 42,
            "Stock Balance": 15,
            Notes:
              "Upload images as: FS0002_1.jpg (main), FS0002_2.jpg (optional), FS0002_3.jpg (optional). Use backend filenames from CSV mapping in image columns above.",
          },
        ];
        fileName = `jeans_upload_template_${
          new Date().toISOString().split("T")[0]
        }.xlsx`;
        break;

      case "other":
        templateData = [
          {
            "Product Name": "FS0003",
            Description:
              "Premium quality leather belt with durable construction",
            Category: "Accessories",
            "Product Type": "Belt",
            "New Price": 799,
            "Old Price": 999,
            "Image Main (Backend Filename)": "product_1234567890123.webp",
            "Image Optional 2 (Backend Filename)": "product_1234567890124.webp",
            "Image Optional 3 (Backend Filename)": "product_1234567890125.webp",
            "Length (inches)": 42,
            "Stock Balance": 20,
            Notes:
              "Upload images as: FS0003_1.jpg (main), FS0003_2.jpg (optional), FS0003_3.jpg (optional). Use backend filenames from CSV mapping in image columns above.",
          },
        ];
        fileName = `other_accessories_upload_template_${
          new Date().toISOString().split("T")[0]
        }.xlsx`;
        break;

      default:
        templateData = [
          {
            "Product Name": "FS0001",
            Description:
              "Premium quality cotton t-shirt with comfortable fit and modern design",
            Category: "Men",
            "New Price": 999,
            "Old Price": 1299,
            "Image Main (Backend Filename)": "product_1234567890123.webp",
            "Image Optional 2 (Backend Filename)": "product_1234567890124.webp",
            "Image Optional 3 (Backend Filename)": "product_1234567890125.webp",
            "Size S Available": "Yes",
            "Size S Chest (inches)": 36,
            "Size S Shoulder (inches)": 16,
            "Size S Length (inches)": 28,
            "Size S Sleeve (inches)": 24,
            "Size S Stock Balance": 10,
            "Size M Available": "Yes",
            "Size M Chest (inches)": 38,
            "Size M Shoulder (inches)": 17,
            "Size M Length (inches)": 29,
            "Size M Sleeve (inches)": 25,
            "Size M Stock Balance": 15,
            "Size L Available": "Yes",
            "Size L Chest (inches)": 40,
            "Size L Shoulder (inches)": 18,
            "Size L Length (inches)": 30,
            "Size L Sleeve (inches)": 26,
            "Size L Stock Balance": 12,
            "Size XL Available": "Yes",
            "Size XL Chest (inches)": 42,
            "Size XL Shoulder (inches)": 19,
            "Size XL Length (inches)": 31,
            "Size XL Sleeve (inches)": 27,
            "Size XL Stock Balance": 8,
            "Size XXL Available": "No",
            "Size XXL Chest (inches)": 0,
            "Size XXL Shoulder (inches)": 0,
            "Size XXL Length (inches)": 0,
            "Size XXL Sleeve (inches)": 0,
            "Size XXL Stock Balance": 0,
            Notes:
              "Upload images as: FS0001_1.jpg (main), FS0001_2.jpg (optional), FS0001_3.jpg (optional). Use backend filenames from CSV mapping in image columns above.",
          },
        ];
        fileName = `shirts_upload_template_${
          new Date().toISOString().split("T")[0]
        }.xlsx`;
    }

    const ws = XLSX.utils.json_to_sheet(templateData);
    const wb = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(wb, ws, "Product Template");

    // Auto-size columns
    const colWidths = [];
    Object.keys(templateData[0]).forEach((key, index) => {
      colWidths[index] = Math.max(key.length + 2, 20);
    });
    ws["!cols"] = colWidths.map((width) => ({ width }));

    XLSX.writeFile(wb, fileName);
  };

  // Handle bulk file upload
  const handleBulkFileChange = (e) => {
    const file = e.target.files[0];
    if (
      file &&
      file.type ===
        "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
    ) {
      setBulkFile(file);
    } else {
      window.alert("Please select a valid Excel file (.xlsx)");
    }
  };

  // Process bulk upload
  const handleBulkUpload = async () => {
    if (!bulkFile) {
      window.alert("Please select an Excel file first");
      return;
    }

    try {
      setBulkUploading(true);
      setBulkProgress({ current: 0, total: 0 });

      const data = await new Promise((resolve, reject) => {
        const reader = new FileReader();
        reader.onload = (e) => {
          try {
            const workbook = XLSX.read(e.target.result, { type: "binary" });
            const sheetName = workbook.SheetNames[0];
            const worksheet = workbook.Sheets[sheetName];
            const jsonData = XLSX.utils.sheet_to_json(worksheet);

            if (!jsonData || jsonData.length === 0) {
              reject(
                new Error("Excel file appears to be empty or has no data")
              );
            }

            console.log("Excel data loaded:", jsonData.length, "rows");
            resolve(jsonData);
          } catch (error) {
            console.error("Error reading Excel file:", error);
            reject(new Error(`Failed to read Excel file: ${error.message}`));
          }
        };
        reader.onerror = () => {
          reject(new Error("Failed to read file"));
        };
        reader.readAsBinaryString(bulkFile);
      });

      setBulkProgress({ current: 0, total: data.length });

      // Transform Excel data to match product schema
      const products = data.map((row, index) => {
        const baseProduct = {
          name: row["Product Name"] || "",
          description: row["Description"] || "",
          category: row["Category"] || "Men",
          new_price: Number(row["New Price"]) || 0,
          old_price: Number(row["Old Price"]) || Number(row["New Price"]) || 0,
          image_main:
            row["Image Main (Backend Filename)"] || row["Image Main"] || "",
          image_back:
            row["Image Optional 2 (Backend Filename)"] ||
            row["Image Back"] ||
            "",
          image_side:
            row["Image Optional 3 (Backend Filename)"] ||
            row["Image Side"] ||
            "",
          updated_by: "Admin",
        };

        // Handle different product types based on template
        if (row["Product Type"] === "Jeans") {
          return {
            ...baseProduct,
            productType: "Jeans",
            waist: Number(row["Waist (inches)"]) || 0,
            thighs: Number(row["Thighs (inches)"]) || 0,
            length: Number(row["Length (inches)"]) || 0,
            stock_bal: Number(row["Stock Balance"]) || 0,
            // Set default size checkboxes to false for accessories
            sizeSCheckbox: false,
            sizeMCheckbox: false,
            sizeLCheckbox: false,
            sizeXLCheckbox: false,
            sizeXXLCheckbox: false,
            sizeSCH: "0",
            sizeSSH: "0",
            sizeSLE: "0",
            sizeSSL: "0",
            stock_balS: "0",
            sizeMCH: "0",
            sizeMSH: "0",
            sizeMLE: "0",
            sizeMSL: "0",
            stock_balM: "0",
            sizeLCH: "0",
            sizeLSH: "0",
            sizeLLE: "0",
            sizeLSL: "0",
            stock_balL: "0",
            sizeXLCH: "0",
            sizeXLSH: "0",
            sizeXLLE: "0",
            sizeXLSL: "0",
            stock_balXL: "0",
            sizeXXLCH: "0",
            sizeXXLSH: "0",
            sizeXXLLE: "0",
            sizeXXLSL: "0",
            stock_balXXL: "0",
          };
        } else if (row["Product Type"] === "Belt" || row["Length (inches)"]) {
          return {
            ...baseProduct,
            productType: row["Product Type"] || "Other",
            length: Number(row["Length (inches)"]) || 0,
            stock_bal: Number(row["Stock Balance"]) || 0,
            // Set default size checkboxes to false for accessories
            sizeSCheckbox: false,
            sizeMCheckbox: false,
            sizeLCheckbox: false,
            sizeXLCheckbox: false,
            sizeXXLCheckbox: false,
            sizeSCH: "0",
            sizeSSH: "0",
            sizeSLE: "0",
            sizeSSL: "0",
            stock_balS: "0",
            sizeMCH: "0",
            sizeMSH: "0",
            sizeMLE: "0",
            sizeMSL: "0",
            stock_balM: "0",
            sizeLCH: "0",
            sizeLSH: "0",
            sizeLLE: "0",
            sizeLSL: "0",
            stock_balL: "0",
            sizeXLCH: "0",
            sizeXLSH: "0",
            sizeXLLE: "0",
            sizeXLSL: "0",
            stock_balXL: "0",
            sizeXXLCH: "0",
            sizeXXLSH: "0",
            sizeXXLLE: "0",
            sizeXXLSL: "0",
            stock_balXXL: "0",
          };
        } else {
          // Default to shirts template with size parameters
          return {
            ...baseProduct,
            sizeSCheckbox: row["Size S Available"] === "Yes",
            sizeSCH: row["Size S Chest (inches)"] || "0",
            sizeSSH: row["Size S Shoulder (inches)"] || "0",
            sizeSLE: row["Size S Length (inches)"] || "0",
            sizeSSL: row["Size S Sleeve (inches)"] || "0",
            stock_balS: row["Size S Stock Balance"] || "0",
            sizeMCheckbox: row["Size M Available"] === "Yes",
            sizeMCH: row["Size M Chest (inches)"] || "0",
            sizeMSH: row["Size M Shoulder (inches)"] || "0",
            sizeMLE: row["Size M Length (inches)"] || "0",
            sizeMSL: row["Size M Sleeve (inches)"] || "0",
            stock_balM: row["Size M Stock Balance"] || "0",
            sizeLCheckbox: row["Size L Available"] === "Yes",
            sizeLCH: row["Size L Chest (inches)"] || "0",
            sizeLSH: row["Size L Shoulder (inches)"] || "0",
            sizeLLE: row["Size L Length (inches)"] || "0",
            sizeLSL: row["Size L Sleeve (inches)"] || "0",
            stock_balL: row["Size L Stock Balance"] || "0",
            sizeXLCheckbox: row["Size XL Available"] === "Yes",
            sizeXLCH: row["Size XL Chest (inches)"] || "0",
            sizeXLSH: row["Size XL Shoulder (inches)"] || "0",
            sizeXLLE: row["Size XL Length (inches)"] || "0",
            sizeXLSL: row["Size XL Sleeve (inches)"] || "0",
            stock_balXL: row["Size XL Stock Balance"] || "0",
            sizeXXLCheckbox: row["Size XXL Available"] === "Yes",
            sizeXXLCH: row["Size XXL Chest (inches)"] || "0",
            sizeXXLSH: row["Size XXL Shoulder (inches)"] || "0",
            sizeXXLLE: row["Size XXL Length (inches)"] || "0",
            sizeXXLSL: row["Size XXL Sleeve (inches)"] || "0",
            stock_balXXL: row["Size XXL Stock Balance"] || "0",
          };
        }
      });

      // Validate required fields (image_main is optional as backend will auto-match)
      const invalidProducts = products.filter(
        (product, index) =>
          !product.name || !product.description || !product.new_price
      );

      if (invalidProducts.length > 0) {
        const invalidRows = invalidProducts.map(
          (_, index) => products.indexOf(invalidProducts[index]) + 1
        );
        throw new Error(
          `Rows ${invalidRows.join(
            ", "
          )}: Missing required fields (name, description, or price)`
        );
      }

      // Check for missing images and warn user
      const productsWithMissingImages = products.filter(
        (product) => !product.image_main || product.image_main.trim() === ""
      );

      if (productsWithMissingImages.length > 0) {
        const missingImageRows = productsWithMissingImages.map(
          (_, index) => products.indexOf(productsWithMissingImages[index]) + 1
        );
        const warningMessage = `Warning: Products in rows ${missingImageRows.join(
          ", "
        )} have missing main images and will display a placeholder. Continue anyway?`;

        if (!window.confirm(warningMessage)) {
          setBulkUploading(false);
          return;
        }
      }

      setBulkProgress({ current: data.length, total: data.length });

      console.log(
        "Sending bulk upload request with",
        products.length,
        "products"
      );
      console.log("Sample product data:", products[0]);

      // Use bulk upload endpoint for better performance
      const controller = new AbortController();
      const timeoutId = setTimeout(() => controller.abort(), 60000); // 60 second timeout

      const response = await fetch(`${backend_url}/admin/bulk-addproducts`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          "auth-token": localStorage.getItem("auth-token"),
        },
        body: JSON.stringify({ products }),
        signal: controller.signal,
      });

      clearTimeout(timeoutId);

      if (!response.ok) {
        const errorText = await response.text();
        console.error(`HTTP ${response.status}: ${errorText}`);

        if (response.status === 502) {
          throw new Error(
            `Backend server is not responding (502 Bad Gateway). Please try again in a few minutes.`
          );
        } else if (response.status === 403) {
          throw new Error(
            `Access denied (403). This might be a CORS issue. Please check your network connection.`
          );
        } else {
          throw new Error(
            `Bulk upload failed (HTTP ${response.status}): ${errorText}`
          );
        }
      }

      const result = await response.json();

      setBulkUploading(false);

      if (result.success) {
        const { summary, results } = result;
        const { successful, failed } = summary;

        if (failed === 0) {
          window.alert(
            `Bulk upload completed successfully! ${successful} products added.`
          );
        } else {
          const errors = results
            .filter((item) => !item.success)
            .map((item) => `Row ${item.index + 1}: ${item.error}`)
            .slice(0, 5);

          window.alert(
            `Bulk upload completed with ${failed} errors.\n\nErrors:\n${errors.join(
              "\n"
            )}${failed > 5 ? "\n... and more" : ""}`
          );
        }
      } else {
        throw new Error(result.message || "Unknown error occurred");
      }

      setBulkFile(null);
      setBulkProgress({ current: 0, total: 0 });
    } catch (error) {
      setBulkUploading(false);
      console.error("Bulk upload error:", error);
      window.alert(`Error processing bulk upload: ${error.message}`);
    }
  };

  const changeHandler = (e) => {
    const { name, value, type, checked } = e.target;
    const newValue = type === "checkbox" ? checked : value;

    setProductDetails((prev) => {
      const updated = {
        ...prev,
        [name]: newValue,
      };

      // Auto-calculate stock balance for all categories when stock_qty or stock_left changes
      if (name === "stock_qty" || name === "stock_left") {
        const stockQty =
          Number(name === "stock_qty" ? newValue : prev.stock_qty) || 0;
        const stockLeft =
          Number(name === "stock_left" ? newValue : prev.stock_left) || 0;
        updated.stock_bal = stockQty - stockLeft;
      }

      return updated;
    });
  };

  // Handle category change to reset product type
  const handleCategoryChange = (e) => {
    const newCategory = e.target.value;
    setProductDetails({
      ...productDetails,
      category: newCategory,
      productType: "", // Reset product type when category changes
    });
  };

  // Render size fields based on category and product type
  const renderSizeFields = () => {
    if (productDetails.category === "Accessories") {
      if (productDetails.productType === "Jeans") {
        return (
          <div className="accessory-fields">
            <h3>Jeans Measurements</h3>
            <div className="addproduct-itemfield5">
              <p>Waist :</p>
              <input
                type="number"
                name="waist"
                value={productDetails.waist}
                onChange={changeHandler}
                placeholder="Inches"
                required
              />
              <p>Thighs :</p>
              <input
                type="number"
                name="thighs"
                value={productDetails.thighs}
                onChange={changeHandler}
                placeholder="Inches"
                required
              />
              <p>Length :</p>
              <input
                type="number"
                name="length"
                value={productDetails.length}
                onChange={changeHandler}
                placeholder="Inches"
                required
              />
              <p>Stock Balance :</p>
              <input
                type="number"
                name="stock_bal"
                value={productDetails.stock_bal}
                onChange={changeHandler}
                placeholder="Qty"
                required
              />
            </div>
          </div>
        );
      } else if (productDetails.productType === "Belt") {
        return (
          <div className="accessory-fields">
            <h3>Belt Measurements</h3>
            <div className="addproduct-itemfield5">
              <p>Length :</p>
              <input
                type="number"
                name="length"
                value={productDetails.length}
                onChange={changeHandler}
                placeholder="Inches"
                required
              />
              <p>Stock Balance :</p>
              <input
                type="number"
                name="stock_bal"
                value={productDetails.stock_bal}
                onChange={changeHandler}
                placeholder="Qty"
                required
              />
            </div>
          </div>
        );
      } else if (productDetails.productType === "Other") {
        // Generic accessory (no specific measurements)
        return (
          <div className="accessory-fields">
            <h3>General Accessory</h3>
            <div className="addproduct-itemfield5">
              <p>Stock Balance :</p>
              <input
                type="number"
                name="stock_bal"
                value={productDetails.stock_bal}
                onChange={changeHandler}
                placeholder="Qty"
                required
              />
            </div>
          </div>
        );
      }
      return null;
    }

    // Original size fields for Men and Kids categories
    return renderOriginalSizeFields();
  };

  const renderOriginalSizeFields = () => {
    return (
      <>
        <div className="sizename addproduct-itemfield3">
          <p>Size Small :</p>
          <input
            className="sizeClass"
            type="checkbox"
            name="sizeSCheckbox"
            checked={productDetails.sizeSCheckbox}
            onChange={(e) =>
              setProductDetails({
                ...productDetails,
                sizeSCheckbox: e.target.checked,
              })
            }
          />
        </div>
        {productDetails.sizeSCheckbox && (
          <section className="sizeSsection">
            <div className="addproduct-itemfield5">
              <p>Chest :</p>
              <input
                type="number"
                name="sizeSCH"
                value={productDetails.sizeSCH}
                onChange={changeHandler}
                placeholder="Inch"
                required
              />
              <p>Shoulder :</p>
              <input
                type="number"
                name="sizeSSH"
                value={productDetails.sizeSSH}
                onChange={changeHandler}
                placeholder="Inch"
                required
              />
              <p>Length :</p>
              <input
                type="number"
                name="sizeSLE"
                value={productDetails.sizeSLE}
                onChange={changeHandler}
                placeholder="Inch"
                required
              />
              <p>Sleeve :</p>
              <input
                type="number"
                name="sizeSSL"
                value={productDetails.sizeSSL}
                onChange={changeHandler}
                placeholder="Inch"
                required
              />
              <p>Stk Bal :</p>
              <input
                type="number"
                name="stock_balS"
                value={productDetails.stock_balS}
                onChange={changeHandler}
                placeholder="Qty"
                required
              />
            </div>
          </section>
        )}
        <div className="sizename">
          <p>Size Medium :</p>
          <input
            className="sizeClass"
            type="checkbox"
            name="sizeMCheckbox"
            checked={productDetails.sizeMCheckbox}
            onChange={(e) =>
              setProductDetails({
                ...productDetails,
                sizeMCheckbox: e.target.checked,
              })
            }
          />
        </div>
        {productDetails.sizeMCheckbox && (
          <section className="sizeMsection">
            <div className="addproduct-itemfield5 ">
              <p>Chest :</p>
              <input
                type="number"
                name="sizeMCH"
                value={productDetails.sizeMCH}
                onChange={changeHandler}
                placeholder="Inches"
                required
              />
              <p>Shoulder :</p>
              <input
                type="number"
                name="sizeMSH"
                value={productDetails.sizeMSH}
                onChange={changeHandler}
                placeholder="Inches"
                required
              />
              <p>Length :</p>
              <input
                type="number"
                name="sizeMLE"
                value={productDetails.sizeMLE}
                onChange={changeHandler}
                placeholder="Inches"
                required
              />
              <p>Sleeve :</p>
              <input
                type="number"
                name="sizeMSL"
                value={productDetails.sizeMSL}
                onChange={changeHandler}
                placeholder="Inches"
                required
              />
              <p>Stk Bal :</p>
              <input
                type="number"
                name="stock_balM"
                value={productDetails.stock_balM}
                onChange={changeHandler}
                placeholder="Qty"
                required
              />
            </div>
          </section>
        )}
        <div className="sizename">
          <p>Size Large :</p>
          <input
            className="sizeClass"
            type="checkbox"
            name="sizeLCheckbox"
            checked={productDetails.sizeLCheckbox}
            onChange={(e) =>
              setProductDetails({
                ...productDetails,
                sizeLCheckbox: e.target.checked,
              })
            }
          />
        </div>
        {productDetails.sizeLCheckbox && (
          <section className="sizeLsection">
            <div className="addproduct-itemfield5 ">
              <p>Chest :</p>
              <input
                type="number"
                name="sizeLCH"
                value={productDetails.sizeLCH}
                onChange={changeHandler}
                placeholder="Inches"
                required
              />
              <p>Shoulder :</p>
              <input
                type="number"
                name="sizeLSH"
                value={productDetails.sizeLSH}
                onChange={changeHandler}
                placeholder="Inches"
                required
              />
              <p>Length :</p>
              <input
                type="number"
                name="sizeLLE"
                value={productDetails.sizeLLE}
                onChange={changeHandler}
                placeholder="Inches"
                required
              />
              <p>Sleeve :</p>
              <input
                type="number"
                name="sizeLSL"
                value={productDetails.sizeLSL}
                onChange={changeHandler}
                placeholder="Inches"
                required
              />
              <p>Stk Bal :</p>
              <input
                type="number"
                name="stock_balL"
                value={productDetails.stock_balL}
                onChange={changeHandler}
                placeholder="Qty"
                required
              />
            </div>
          </section>
        )}
        <div className="sizename">
          <p>Size X L :</p>
          <input
            className="sizeClass"
            type="checkbox"
            name="sizeXLCheckbox"
            checked={productDetails.sizeXLCheckbox}
            onChange={(e) =>
              setProductDetails({
                ...productDetails,
                sizeXLCheckbox: e.target.checked,
              })
            }
          />
        </div>
        {productDetails.sizeXLCheckbox && (
          <section className="sizeXLsection">
            <div className="sizeDiv addproduct-itemfield5 ">
              <p>Chest :</p>
              <input
                type="number"
                name="sizeXLCH"
                value={productDetails.sizeXLCH}
                onChange={changeHandler}
                placeholder="Inches"
                required
              />
              <p>Shoulder :</p>
              <input
                type="number"
                name="sizeXLSH"
                value={productDetails.sizeXLSH}
                onChange={changeHandler}
                placeholder="Inches"
                required
              />
              <p>Length :</p>
              <input
                type="number"
                name="sizeXLLE"
                value={productDetails.sizeXLLE}
                onChange={changeHandler}
                placeholder="Inches"
                required
              />
              <p>Sleeve :</p>
              <input
                type="number"
                name="sizeXLSL"
                value={productDetails.sizeXLSL}
                onChange={changeHandler}
                placeholder="Inches"
                required
              />
              <p>Stk Bal :</p>
              <input
                type="number"
                name="stock_balXL"
                value={productDetails.stock_balXL}
                onChange={changeHandler}
                placeholder="Qty"
                required
              />
            </div>
          </section>
        )}
        <div className="sizename">
          <p> Size X X L :</p>
          <input
            className="sizeClass"
            type="checkbox"
            name="sizeXXLCheckbox"
            checked={productDetails.sizeXXLCheckbox}
            onChange={(e) =>
              setProductDetails({
                ...productDetails,
                sizeXXLCheckbox: e.target.checked,
              })
            }
          />
        </div>
        {productDetails.sizeXXLCheckbox && (
          <section className="sizeXXLsection">
            <div className="addproduct-itemfield5 ">
              <p>Chest :</p>
              <input
                type="number"
                name="sizeXXLCH"
                value={productDetails.sizeXXLCH}
                onChange={changeHandler}
                placeholder="Inches"
                required
              />
              <p>Shoulder :</p>
              <input
                type="number"
                name="sizeXXLSH"
                value={productDetails.sizeXXLSH}
                onChange={changeHandler}
                placeholder="Inches"
                required
              />
              <p>Length :</p>
              <input
                type="number"
                name="sizeXXLLE"
                value={productDetails.sizeXXLLE}
                onChange={changeHandler}
                placeholder="Inches"
                required
              />
              <p>Sleeve :</p>
              <input
                type="number"
                name="sizeXXLSL"
                value={productDetails.sizeXXLSL}
                onChange={changeHandler}
                placeholder="Inches"
                required
              />
              <p>Stk Bal :</p>
              <input
                type="number"
                name="stock_balXXL"
                value={productDetails.stock_balXXL}
                onChange={changeHandler}
                placeholder="Qty"
                required
              />
            </div>
          </section>
        )}
      </>
    );
  };

  // Updated image handler for multiple images
  const imageHandler = (e, imageType) => {
    const file = e.target.files[0];
    if (file) {
      setImages((prev) => ({
        ...prev,
        [imageType]: file,
      }));
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    // Check if at least the main image is selected
    if (!images.image_main) {
      window.alert("Please select at least the main product image");
      return;
    }

    try {
      // Upload images using the new multiple upload endpoint
      const formData = new FormData();
      if (images.image_main) formData.append("image_main", images.image_main);
      if (images.image_back) formData.append("image_back", images.image_back);
      if (images.image_side) formData.append("image_side", images.image_side);

      console.log("Attempting to upload images...");
      const uploadResponse = await fetch(`${backend_url}/upload-multiple`, {
        method: "POST",
        headers: {
          Accept: "application/json",
          "auth-token": localStorage.getItem("auth-token"),
        },
        body: formData,
      });

      if (!uploadResponse.ok) {
        const errorText = await uploadResponse.text();
        throw new Error(`Image upload failed: ${errorText}`);
      }

      const uploadData = await uploadResponse.json();
      console.log("Image upload response:", uploadData);

      if (uploadData.success) {
        // Create product with multiple image URLs
        const productData = {
          ...productDetails,
          image_main: uploadData.image_urls.image_main || "",
          image_back: uploadData.image_urls.image_back || "",
          image_side: uploadData.image_urls.image_side || "",
        };

        console.log("Attempting to add product with data:", productData);
        const addProductResponse = await fetch(
          `${backend_url}/admin/addproduct`,
          {
            method: "POST",
            headers: {
              "Content-Type": "application/json",
              "auth-token": localStorage.getItem("auth-token"),
            },
            body: JSON.stringify(productData),
          }
        );

        if (!addProductResponse.ok) {
          const errorText = await addProductResponse.text();
          throw new Error(`Add product request failed: ${errorText}`);
        }

        const result = await addProductResponse.json();
        console.log("Add product response:", result);

        if (result.success) {
          window.alert("Product Added Successfully");
          // Reset form
          setProductDetails((prev) => ({
            ...prev,
            name: "",
            description: "",
            new_price: "",
            old_price: "",
            category: "Mens",
            image_main: "",
            image_back: "",
            image_side: "",
          }));
          setImages({
            image_main: null,
            image_back: null,
            image_side: null,
          });
        } else {
          window.alert(
            `Failed to add product: ${result.message || "Unknown error"}`
          );
        }
      }
    } catch (error) {
      console.error("Detailed error:", error);
      window.alert(`Error adding product: ${error.message}`);
    }
  };

  // Bulk image upload handler
  const handleBulkImageChange = (e) => {
    setBulkImageFiles(Array.from(e.target.files));
  };

  // Enhanced bulk image upload handler with CSV mapping
  const handleBulkImageUpload = async () => {
    if (!bulkImageFiles.length) {
      window.alert("Please select image files to upload.");
      return;
    }
    setBulkImageUploading(true);
    try {
      const formData = new FormData();
      bulkImageFiles.forEach((file) => formData.append("images", file));

      const response = await fetch(`${backend_url}/admin/bulk-upload-images`, {
        method: "POST",
        headers: {
          "auth-token": localStorage.getItem("auth-token"),
        },
        body: formData,
      });

      if (!response.ok) {
        const errorText = await response.text();
        throw new Error(`HTTP ${response.status}: ${errorText}`);
      }

      const result = await response.json();
      if (result && result.success) {
        // Use the structured mapping from backend
        setBulkImageUploadResult(result.imageMapping || []);

        // Show success message with mapping file info
        const filenamesCount = result.filenames ? result.filenames.length : 0;
        const patternMismatches = result.patternMismatches
          ? result.patternMismatches.length
          : 0;

        let successMessage = `Uploaded ${filenamesCount} images successfully!\n\n`;

        if (patternMismatches > 0) {
          successMessage += `⚠️ WARNING: ${patternMismatches} files don't follow the naming convention!\n`;
          successMessage += `Please rename them to follow the FS0099_1.jpg format.\n\n`;
        }

        successMessage +=
          `📁 Mapping file saved: ${result.mappingFile || "N/A"}\n` +
          `📊 Total products: ${result.totalProducts || 0}\n\n` +
          `✅ Images are now available in the backend and will be visible to customers.\n` +
          `🔄 Images are being committed to GitHub repository for persistence.\n` +
          `📋 You can download the CSV mapping below for Excel template use.`;

        window.alert(successMessage);
      } else {
        const errorMessage =
          result && result.message
            ? result.message
            : "Bulk image upload failed";
        window.alert(errorMessage);
      }
    } catch (error) {
      console.error("Bulk image upload error:", error);
      window.alert("Error uploading images: " + error.message);
    }
    setBulkImageUploading(false);
    setBulkImageFiles([]);
    if (bulkImageInputRef.current) bulkImageInputRef.current.value = "";
  };

  // Enhanced CSV download with mapping
  const handleDownloadFilenames = () => {
    if (!bulkImageUploadResult.length) return;

    const csvHeader =
      "Product Name,Original Filename,Optional Image File2,Optional Image File3,Backend Filename image-main,Backend Filename image1-optional,Backend Filename image2-optional,Use in Excel Template - image-main,Use in Excel Template - optional image-2,Use in Excel Template - optional image-3";

    const csvRows = bulkImageUploadResult.map((mapping) => {
      if (mapping.productName) {
        // Product-based mapping
        return `${mapping.productName},${mapping.image_main},${mapping.image_optional2},${mapping.image_optional3},${mapping.backend_main},${mapping.backend_optional2},${mapping.backend_optional3},${mapping.backend_main},${mapping.backend_optional2},${mapping.backend_optional3}`;
      } else {
        // Unknown/legacy mapping
        return `N/A,${mapping.originalName || ""},,,${
          mapping.backendName || ""
        },,,,${mapping.backendName || ""},,`;
      }
    });

    const csvContent = [csvHeader, ...csvRows].join("\n");

    const blob = new Blob([csvContent], { type: "text/csv" });
    const url = URL.createObjectURL(blob);
    const a = document.createElement("a");
    a.href = url;
    a.download = "image_filename_mapping.csv";
    a.click();
    URL.revokeObjectURL(url);
  };

  // Download the latest mapping file from backend
  const handleDownloadMappingFile = async () => {
    try {
      const response = await fetch(
        `${backend_url}/admin/latest-upload-mapping`,
        {
          method: "GET",
          headers: {
            "auth-token": localStorage.getItem("auth-token"),
          },
        }
      );

      const result = await response.json();
      if (result.success) {
        // Create and download the JSON mapping file
        const blob = new Blob([JSON.stringify(result.mappingData, null, 2)], {
          type: "application/json",
        });
        const url = URL.createObjectURL(blob);
        const a = document.createElement("a");
        a.href = url;
        a.download = result.mappingFile;
        a.click();
        URL.revokeObjectURL(url);
      } else {
        window.alert("No mapping file found. Please upload images first.");
      }
    } catch (error) {
      window.alert("Error downloading mapping file: " + error.message);
    }
  };

  return (
    <div className="addproduct">
      {/* Upload Mode Toggle */}
      <div className="upload-mode-toggle">
        <h2>Add Products</h2>
        <div className="mode-buttons">
          <button
            type="button"
            className={`mode-btn ${
              uploadMode === "individual" ? "active" : ""
            }`}
            onClick={() => setUploadMode("individual")}
          >
            Individual Upload
          </button>
          <button
            type="button"
            className={`mode-btn ${uploadMode === "bulk" ? "active" : ""}`}
            onClick={() => setUploadMode("bulk")}
          >
            Bulk Upload
          </button>
        </div>
      </div>

      {/* Git Status Display */}
      <div className="git-status-section">
        <h3>Git Configuration Status</h3>
        {gitStatusLoading ? (
          <div className="git-status-loading">
            Checking Git configuration...
          </div>
        ) : gitStatus ? (
          <div className="git-status-info">
            <div className="git-status-grid">
              <div className="git-status-item">
                <span className="git-status-label">Username:</span>
                <span className="git-status-value">
                  {gitStatus.gitConfig.username || "Not configured"}
                </span>
              </div>
              <div className="git-status-item">
                <span className="git-status-label">Email:</span>
                <span className="git-status-value">
                  {gitStatus.gitConfig.email || "Not configured"}
                </span>
              </div>
              <div className="git-status-item">
                <span className="git-status-label">Token:</span>
                <span className="git-status-value">
                  {gitStatus.status.tokenConfigured
                    ? "✅ Configured"
                    : "❌ Not configured"}
                </span>
              </div>
              <div className="git-status-item">
                <span className="git-status-label">Remote:</span>
                <span className="git-status-value">
                  {gitStatus.gitConfig.remoteUrl
                    ? "✅ Configured"
                    : "❌ Not configured"}
                </span>
              </div>
            </div>
            <div className="git-status-summary">
              {gitStatus.status.credentialsConfigured &&
              gitStatus.status.tokenConfigured ? (
                <div className="git-status-success">
                  ✅ Git is properly configured for automatic image commits
                </div>
              ) : (
                <div className="git-status-warning">
                  ⚠️ Git credentials not fully configured. Images may not be
                  committed to repository.
                  <br />
                  <small>
                    Please check the <strong>GIT_SETUP_README.md</strong> file
                    for setup instructions.
                  </small>
                </div>
              )}
            </div>
            <div className="git-status-actions">
              <button
                onClick={checkGitStatus}
                className="git-status-refresh"
                title="Refresh Git status"
              >
                🔄 Refresh Status
              </button>
              <button
                onClick={openLastCommit}
                disabled={openingCommit || !gitStatus?.gitConfig?.lastCommitUrl}
                className="git-status-commit"
                title="Open the most recent commit"
                style={{ marginLeft: 8 }}
              >
                🔗 View Last Commit
              </button>
              {gitStatus?.gitConfig?.lastCommitHash && (
                <span
                  className="git-last-commit-hash"
                  style={{ marginLeft: 8 }}
                >
                  {gitStatus.gitConfig.lastCommitHash.slice(0, 7)}
                </span>
              )}
            </div>
          </div>
        ) : (
          <div className="git-status-error">
            ❌ Failed to load Git configuration status
            <button
              onClick={checkGitStatus}
              className="git-status-refresh"
              title="Retry loading Git status"
            >
              🔄 Retry
            </button>
          </div>
        )}
      </div>

      {uploadMode === "individual" ? (
        // Individual Upload Form
        <form onSubmit={handleSubmit}>
          <div className="addproduct-itemfield">
            <p>Category</p>
            <select
              name="category"
              value={productDetails.category}
              onChange={handleCategoryChange}
              required
            >
              <option value="Men">Men</option>
              <option value="Kids">Kids</option>
              <option value="Accessories">Accessories</option>
            </select>
          </div>

          {productDetails.category === "Accessories" && (
            <div className="addproduct-itemfield">
              <p>Product Type</p>
              <select
                name="productType"
                value={productDetails.productType}
                onChange={changeHandler}
                required
              >
                <option value="">Select Product Type</option>
                <option value="Jeans">Jeans</option>
                <option value="Belt">Belt</option>
                <option value="Other">Other</option>
              </select>
            </div>
          )}

          <div className="addproduct-itemfield">
            <p>Product Title</p>
            <input
              type="text"
              name="name"
              value={productDetails.name}
              onChange={changeHandler}
              placeholder="Type here"
              required
            />
          </div>

          <div className="addproduct-itemfield">
            <p>Description</p>
            <textarea
              name="description"
              value={productDetails.description}
              onChange={changeHandler}
              placeholder="Type here"
              required
            />
          </div>

          {renderSizeFields()}

          <div className="addproduct-price">
            <div className="addproduct-itemfield">
              <p>Price</p>
              <input
                type="number"
                name="new_price"
                value={productDetails.new_price}
                onChange={changeHandler}
                placeholder="Type here"
                required
              />
            </div>
            <div className="addproduct-itemfield">
              <p>Old Price</p>
              <input
                type="number"
                name="old_price"
                value={productDetails.old_price}
                onChange={changeHandler}
                placeholder="Type here"
                required
              />
            </div>
          </div>

          <div className="multiple-images-container">
            <div className="addproduct-itemfield">
              <p>Main Image</p>
              <label className="upload-area">
                <img
                  src={
                    images.image_main
                      ? URL.createObjectURL(images.image_main)
                      : upload_area
                  }
                  alt=""
                />
                <input
                  type="file"
                  name="image_main"
                  onChange={(e) => imageHandler(e, "image_main")}
                  accept="image/*"
                  style={{ display: "none" }}
                  required
                />
              </label>
            </div>

            <div className="addproduct-itemfield">
              <p>Back Image (Optional)</p>
              <label className="upload-area">
                <img
                  src={
                    images.image_back
                      ? URL.createObjectURL(images.image_back)
                      : upload_area
                  }
                  alt=""
                />
                <input
                  type="file"
                  name="image_back"
                  onChange={(e) => imageHandler(e, "image_back")}
                  accept="image/*"
                  style={{ display: "none" }}
                />
              </label>
            </div>

            <div className="addproduct-itemfield">
              <p>Side Image (Optional)</p>
              <label className="upload-area">
                <img
                  src={
                    images.image_side
                      ? URL.createObjectURL(images.image_side)
                      : upload_area
                  }
                  alt=""
                />
                <input
                  type="file"
                  name="image_side"
                  onChange={(e) => imageHandler(e, "image_side")}
                  accept="image/*"
                  style={{ display: "none" }}
                />
              </label>
            </div>
          </div>

          <button className="addproduct-btn" type="submit">
            ADD PRODUCT
          </button>
        </form>
      ) : (
        // Bulk Upload Form
        <div className="bulk-upload-container">
          {/* Bulk Image Upload at the top */}
          <div className="bulk-image-upload-section">
            <h3>Bulk Image Upload</h3>
            <p>
              <strong>⚠️ IMPORTANT:</strong> Upload product images first using
              the correct naming convention:
            </p>
            <div
              style={{
                background: "#fff3cd",
                border: "1px solid #ffeaa7",
                borderRadius: "8px",
                padding: "15px",
                marginBottom: "15px",
                fontSize: "14px",
              }}
            >
              <strong>Required Format:</strong>
              <br />• <strong>FS0099_1.jpg</strong> (Main image - REQUIRED)
              <br />• <strong>FS0099_2.jpg</strong> (Back image - OPTIONAL)
              <br />• <strong>FS0099_3.jpg</strong> (Side image - OPTIONAL)
              <br />
              <br />
              <strong>Key Points:</strong>
              <br />
              • Product code must start with 2 letters + numbers (FS0099,
              FS0100, etc.)
              <br />• Use underscore <code>_</code> to separate product code
              from image number
              <br />• Use <code>_1</code> for main image, <code>_2</code> for
              back, <code>_3</code> for side
              <br />• Supported formats: .jpg, .jpeg, .png, .webp
            </div>
            <input
              type="file"
              accept="image/*"
              multiple
              ref={bulkImageInputRef}
              onChange={handleBulkImageChange}
              disabled={bulkImageUploading}
              style={{ marginBottom: 8 }}
            />
            <button
              onClick={handleBulkImageUpload}
              disabled={bulkImageUploading || !bulkImageFiles.length}
              style={{ marginLeft: 8 }}
            >
              {bulkImageUploading ? "Uploading..." : "Upload Selected Images"}
            </button>
            {bulkImageUploadResult.length > 0 && (
              <div style={{ marginTop: 12 }}>
                <strong>Image Upload Results:</strong>
                <div
                  style={{
                    maxHeight: 300,
                    overflowY: "auto",
                    background: "#fafafa",
                    border: "1px solid #eee",
                    padding: 8,
                    borderRadius: 4,
                    marginTop: 8,
                  }}
                >
                  <table style={{ width: "100%", fontSize: 11 }}>
                    <thead>
                      <tr style={{ background: "#e9ecef" }}>
                        <th style={{ padding: 4, textAlign: "left" }}>
                          Product
                        </th>
                        <th style={{ padding: 4, textAlign: "left" }}>
                          Main Image
                        </th>
                        <th style={{ padding: 4, textAlign: "left" }}>
                          Optional 2
                        </th>
                        <th style={{ padding: 4, textAlign: "left" }}>
                          Optional 3
                        </th>
                      </tr>
                    </thead>
                    <tbody>
                      {bulkImageUploadResult.map((mapping, idx) => (
                        <tr key={idx}>
                          <td
                            style={{
                              padding: 4,
                              fontFamily: "monospace",
                              fontWeight: "bold",
                            }}
                          >
                            {mapping.productName || "Unknown"}
                          </td>
                          <td
                            style={{
                              padding: 4,
                              fontFamily: "monospace",
                              color: "#007bff",
                            }}
                          >
                            {mapping.backend_main || mapping.backendName || "-"}
                          </td>
                          <td
                            style={{
                              padding: 4,
                              fontFamily: "monospace",
                              color: "#007bff",
                            }}
                          >
                            {mapping.backend_optional2 || "-"}
                          </td>
                          <td
                            style={{
                              padding: 4,
                              fontFamily: "monospace",
                              color: "#007bff",
                            }}
                          >
                            {mapping.backend_optional3 || "-"}
                          </td>
                        </tr>
                      ))}
                    </tbody>
                  </table>
                </div>
                <div
                  style={{
                    marginTop: 8,
                    display: "flex",
                    gap: 8,
                    flexWrap: "wrap",
                  }}
                >
                  <button
                    onClick={handleDownloadFilenames}
                    style={{
                      padding: "8px 16px",
                      backgroundColor: "#28a745",
                      color: "white",
                      border: "none",
                      borderRadius: 4,
                      cursor: "pointer",
                    }}
                  >
                    📄 Download CSV Mapping
                  </button>
                  <button
                    onClick={handleDownloadMappingFile}
                    style={{
                      padding: "8px 16px",
                      backgroundColor: "#007bff",
                      color: "white",
                      border: "none",
                      borderRadius: 4,
                      cursor: "pointer",
                    }}
                  >
                    📁 Download JSON Mapping
                  </button>
                </div>
                <div style={{ fontSize: 12, color: "#888", marginTop: 8 }}>
                  <strong>📋 Instructions:</strong>
                  <br />• <strong>CSV Mapping:</strong> Use the{" "}
                  <strong>Backend Filename</strong> column values in your Excel
                  template's <b>Image Main</b>, <b>Image Back</b>, and{" "}
                  <b>Image Side</b> columns.
                  <br />• <strong>JSON Mapping:</strong> Complete upload details
                  for verification and debugging.
                </div>
              </div>
            )}
          </div>

          {/* Step 1: Download Template (green box) */}
          <div className="template-section">
            <h4>Step 1: Download Template</h4>
            <div className="template-selection">
              <label>Select Template Type:</label>
              <select
                value={selectedTemplate}
                onChange={(e) => setSelectedTemplate(e.target.value)}
                style={{
                  padding: "8px 12px",
                  borderRadius: "4px",
                  border: "1px solid #ddd",
                  marginRight: "15px",
                  marginLeft: "10px",
                  fontSize: "14px",
                }}
              >
                <option value="shirts">
                  Shirts (Men/Kids) - Sleeve, Length, Shoulder, Stock Balance
                </option>
                <option value="jeans">
                  Jeans (Accessories) - Waist, Thighs, Length, Stock Balance
                </option>
                <option value="other">
                  Other Items (Belts etc.) - Length, Stock Balance
                </option>
              </select>
              <button
                type="button"
                className="template-btn"
                onClick={generateExcelTemplate}
              >
                Download Excel Template
              </button>
            </div>
            <p>
              Select the appropriate template type for your products, download
              the Excel template, fill in your product data, and upload it in
              Step 2.
            </p>
          </div>

          {/* Step 2: Upload Excel File (blue box with folder icon) */}
          <div className="upload-section">
            <h4>Step 2: Upload Excel File</h4>
            <div className="file-upload-area">
              <input
                type="file"
                name="bulkFile"
                onChange={handleBulkFileChange}
                accept=".xlsx"
                id="bulkFileInput"
                style={{ display: "none" }}
              />
              <label htmlFor="bulkFileInput" className="file-upload-label">
                <div className="upload-icon">📁</div>
                <div className="upload-text">
                  {bulkFile
                    ? bulkFile.name
                    : "Click to select Excel file (.xlsx)"}
                </div>
                <div className="upload-hint">
                  Only .xlsx files are supported
                </div>
              </label>
            </div>
          </div>

          {/* Start Bulk Upload button centered */}
          <div className="bulk-upload-actions">
            <button
              type="button"
              className="bulk-upload-btn"
              onClick={handleBulkUpload}
              disabled={!bulkFile || bulkUploading}
            >
              {bulkUploading ? "Uploading..." : "Start Bulk Upload"}
            </button>
          </div>

          {/* Step-by-step instructions in a yellow box at the bottom */}
          <div className="bulk-upload-info">
            <h4>Step-by-Step Instructions:</h4>

            {/* Add warning about image upload requirement */}
            <div
              style={{
                background: "#fff3cd",
                border: "1px solid #ffeaa7",
                borderRadius: "8px",
                padding: "15px",
                marginBottom: "20px",
                color: "#856404",
              }}
            >
              <strong>⚠️ Important:</strong> You <strong>MUST</strong> upload
              your product images first using the "Bulk Image Upload" section
              above before uploading your Excel file. Products with missing
              images will display a placeholder image.
            </div>

            <ol>
              <li>
                <strong>Name Your Images:</strong> Name your image files using
                the product-based format:
                <ul>
                  <li>
                    <strong>Main Image:</strong> ProductName_1.jpg (e.g.,
                    FS0001_1.jpg)
                  </li>
                  <li>
                    <strong>Optional Image 2:</strong> ProductName_2.jpg (e.g.,
                    FS0001_2.jpg)
                  </li>
                  <li>
                    <strong>Optional Image 3:</strong> ProductName_3.jpg (e.g.,
                    FS0001_3.jpg)
                  </li>
                </ul>
              </li>
              <li>
                <strong>Upload Images:</strong> Use the "Bulk Image Upload"
                section above to upload all your product images
              </li>
              <li>
                <strong>Download Mapping:</strong> Click "Download Filename
                Mapping CSV" to get the backend filenames organized by product
              </li>
              <li>
                <strong>Download Template:</strong> Download the Excel template
                from Step 1
              </li>
              <li>
                <strong>Fill Template:</strong> Enter your product data in the
                Excel file:
                <ul>
                  <li>
                    Use backend filenames from the CSV in image columns (Image
                    Main, Image Optional 2, Image Optional 3)
                  </li>
                  <li>
                    Product Name, Description, New Price, and Image Main are{" "}
                    <strong>required</strong>
                  </li>
                  <li>Optional images will show "No Image" if not provided</li>
                  <li>For size availability, use "Yes" or "No"</li>
                  <li>Categories: Men, Kids, Accessories</li>
                  <li>All measurements should be in inches</li>
                  <li>Stock quantities should be numbers</li>
                </ul>
              </li>
              <li>
                <strong>Upload Excel:</strong> Upload your completed Excel file
                using Step 2
              </li>
            </ol>
          </div>
        </div>
      )}
    </div>
  );
};

export default AddProduct;
